import axios from 'axios';
import * as Cache from '../../utils/Cache';

import Settings from '../../settings';

const remote = Settings.remote;

/*export function toCache(slug,response) {
  return function(dispatch) {
    cache.push({
            slug: slug,
            response: response
          })
  }
}*/

export function getHome(slug) {
  return function (dispatch) {
    dispatch({ type: 'GETTING_HOME' });

    console.log('getHome slug', slug);

    if (slug === '/projects' || slug === '/projects/') slug = 'showcase';

    // check for cache
    let cached = false; //Cache.fetch(slug);

    if (cached) {
      dispatch({ type: 'GOT_HOME', payload: cached.response.data });
    } else {
      ///console.log('url',remote + slug + '.json');

      axios.get(remote + slug + '.json').then((response) => {
        console.log('Response type:', response.data.type);

        if (response.data.type === 'projects') {
          // try again!

          axios.get(remote + 'showcase.json').then((response2) => {
            dispatch({ type: 'GOT_HOME', payload: response2.data });
          });
        } else {
          // Cache.save(slug, response);
          /*cache.push({
          slug: slug,
          response: response
        })*/

          //console.log('response', response);
          dispatch({ type: 'GOT_HOME', payload: response.data });
        }
      });
    }
  };
}

export function fetchArchive() {
  return function (dispatch) {
    dispatch({ type: 'GETTING_ARCHIVE' });

    ///console.log('url',remote + slug + '.json');

    axios.get(remote + 'archive.json').then((response) => {
      //console.log('response', response);
      dispatch({ type: 'GOT_ARCHIVE', payload: response.data.data });
    });
  };
}

export function fetchNewArchive() {
  return function (dispatch) {
    dispatch({ type: 'GETTING_NEW_ARCHIVE' });

    ///console.log('url',remote + slug + '.json');

    axios.get(remote + 'archive-new.json').then((response) => {
      console.log('GOT_NEW_ARCHIVE', response.data);
      dispatch({ type: 'GOT_NEW_ARCHIVE', payload: response.data.projects });
    });
  };
}

/*
  
  Get data for landing page

*/
export function getLandingPage() {
  return function (dispatch) {
    dispatch({ type: 'GETTING_LANDING_PAGE' });

    const slug = 'landing';

    // check for cache
    let cached = Cache.fetch(slug);

    if (cached) {
      dispatch({ type: 'GOT_LANDING_PAGE', payload: cached.response.data });
    } else {
      //console.log('url',remote + slug + '.json');

      axios.get(remote + slug + '.json').then((response) => {
        Cache.save(slug, response);

        //console.log('response', response);
        dispatch({ type: 'GOT_LANDING_PAGE', payload: response.data });
      });
    }
  };
}

/*
  
  Get data for page

*/
export function getPage(slug) {
  return function (dispatch) {
    dispatch({ type: 'GETTING_PAGE' });

    if (slug === '' || slug === '/') slug = 'showcase';

    // check for cache
    let cached = Cache.fetch(slug);

    if (cached) {
      dispatch({ type: 'GOT_PAGE', payload: cached.response.data });
    } else {
      //console.log('url',remote + slug + '.json');

      axios.get(remote + slug + '.json').then((response) => {
        Cache.save(slug, response);

        //console.log('response', response);
        dispatch({ type: 'GOT_PAGE', payload: response.data });
      });
    }
  };
}

export function clearArticle() {
  return function (dispatch) {
    dispatch({ type: 'CLEARING_ARTICLE' });
  };
}

export function getArticle(slug) {
  return function (dispatch) {
    dispatch({ type: 'GETTING_ARTICLE' });

    if (slug === '' || slug === '/') slug = 'showcase';

    // check for cache
    let cached = Cache.fetch(slug);

    if (cached) {
      dispatch({ type: 'GOT_ARTICLE', payload: cached.response.data });
    } else {
      //console.log('url',remote + slug + '.json');

      const actualSlug = slug.replace('/projects/', '').replace('/', '');

      axios.get(remote + actualSlug + '.json').then((response) => {
        Cache.save(slug, response);

        //console.log('response', response);
        dispatch({ type: 'GOT_ARTICLE', payload: response.data });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/redux/actions/Page.js